import { UseControllerProps } from 'react-hook-form';
type Props = {
  required: boolean;
};
export const MOBILE_NUMBER_RULE: ({
  required,
}: Props) => UseControllerProps['rules'] = ({ required }: Props) => {
  if (required) {
    return {
      required: {
        value: required,
        message: 'وارد کردن شماره تلفن همراه الزامی می باشد',
      },
      minLength: { value: 11, message: 'لطفا تلفن همراه را کامل وارد کنید' },
      maxLength: { value: 11, message: 'لطفا تلفن همراه را کامل وارد کنید' },
      pattern: {
        value: /^09[0-9]{9}$/,
        message: ' تلفن همراه را به درستی وارد کنید ( 10 رقمی بدون صفر )',
      },
    };
  }
  return {
    required: false,
  };
};
